import React, { FC } from 'react';
import { ClientListItem } from '../../ClientListModel';
import { DataTable, ColumnConfig } from '../../../DataTable';

interface Props {
  translation: any;
  groupByOption: string;
  columns: ColumnConfig<ClientListItem>[];
  selectedColumns: string[];
  rows: ClientListItem[];
  onSelectColumns(columns: string[]): void;
}

export const ReportTable: FC<Props> = ({ translation, groupByOption, selectedColumns, columns, rows, onSelectColumns }) => {
  const groupKey = groupByOption !== 'noGrouping' ? groupByOption : undefined;

  return <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} groupByKey={groupKey} emptyMessage={translation.text_6448} />;
};
